<template>
  <v-content>
    <v-card max-width="40%" class="py-2 px-2" justify="center">
      <v-card-title>
        <h2>Welcome</h2>
      </v-card-title>
      <v-card-content class="text--secondary">
        While there's not much here yet, there's plenty I can do for you.
        <br />Get in touch and let's build something for you
        <span class="font-weight-medium">and</span> your customers to enjoy!
        <br />
      </v-card-content>
      <v-btn class="mx-2 my-2" text to="/contact">
        Contact Us
      </v-btn>
    </v-card>
  </v-content>
</template>

<script>
export default {
  name: "HomePage",
  data: () => ({}),
};
</script>

<style scoped></style>
